import React, {Component} from "react";
import { flowRight as compose } from "lodash";
import Form from "../../components/forms/ConfirmForm";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { cancelDeleteNote } from "../NotesActions";
import { connect } from "react-redux";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class DeleteNoteFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(_values) {
    return this.props.deleteNote({noteId: this.props.noteId})
      .then((response) => {
        if (response.data.deleteNote.errors.length <= 0) {
          this.props.cancelDeleteNote(this.props.noteId);
        } else {
          let errors = createValidationErrors(response.data.deleteNote.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelDeleteNote(this.props.noteId);
  }

  render() {
    return (
      <Form
        message="Are you sure you want to delete this note?"
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const DELETE_NOTE = gql`
  mutation deleteNote($data: DeleteNoteInput!) {
    deleteNote(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(DELETE_NOTE, {
    props: ({ mutate }) => ({
      deleteNote: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);


export default connect(null, {cancelDeleteNote})(withQueries(DeleteNoteFormContainer));